const DB_NAME = "csp-offline";
const STORE = "pending-components";
const VERSION = 1;

function openDb() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) db.createObjectStore(STORE, { keyPath: "id" });
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export async function enqueue(item) {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readwrite");
    tx.objectStore(STORE).put(item);
    tx.oncomplete = () => resolve(item);
    tx.onerror = () => reject(tx.error);
  });
}

export async function getAll() {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readonly");
    const rq = tx.objectStore(STORE).getAll();
    rq.onsuccess = () => resolve(rq.result || []);
    rq.onerror = () => reject(rq.error);
  });
}

export async function remove(id) {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readwrite");
    tx.objectStore(STORE).delete(id);
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}

export async function count() {
  return (await getAll()).length;
}

export function dataUrlToBlob(dataUrl) {
  const [meta, b64] = dataUrl.split(",");
  const mime = (meta.match(/:(.*?);/) || [])[1] || "image/jpeg";
  const bin = atob(b64);
  const arr = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
  return new Blob([arr], { type: mime });
}

// Globale Synchronisierung aller offline gepufferten Erfassungen ans Backend.
// Läuft unabhängig von der Erfassungs-Seite (siehe OfflineSyncProvider).
export async function syncPending(api) {
  const items = await getAll();
  if (!items.length) return 0;
  let ok = 0;
  for (const item of items) {
    try {
      const media_ids = [];
      for (const p of (item.photos || [])) {
        const fd = new FormData();
        fd.append("file", dataUrlToBlob(p.dataUrl), p.name || "foto.jpg");
        fd.append("category", p.category || "Hauptschild");
        fd.append("asset_id", item.assetId);
        const { data } = await api.post("/media/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        media_ids.push(data.id);
      }
      await api.post(`/v1/assets/${item.assetId}/components`, {
        art_key: item.art_key, kind: item.kind, bezeichnung: item.fields.bezeichnung,
        manufacturer: item.fields.manufacturer || null, modell: item.fields.modell || null,
        serial_no: item.fields.serial_no || null, auftragsnummer: item.fields.auftragsnummer || null, baujahr: item.fields.baujahr || null,
        specs: item.specs || {}, photos: media_ids, typenschild_media_id: media_ids[0] || null,
      });
      await remove(item.id); ok += 1;
    } catch (e) { /* später erneut versuchen */ }
  }
  return ok;
}
